import React from "react";

export const Label = ({ className = "", children, htmlFor }) => {
  return (
    <label htmlFor={htmlFor} className={`text-white/90 ${className}`}>
      {children}
    </label>
  );
};


